import { MdClose } from "react-icons/md";
import { useMenuContext } from "../../../../context/MenuContext";
import { useInfoUser } from "../../../../store/UserStore";
import { PanelView } from "../PanelView";

const GroupInfoPanel = ({ jumpToMessage, openModal, isMail = false }) => {
  const { setPanelStatus } = useMenuContext();
  const { languageMap } = useInfoUser();

  return (
    <div className="chat-right-panel h-screen bg-white border-l flex flex-col">
      {/* Header */}
      <div className="relative p-3 border-b flex justify-center items-center h-[70px]">
        <span className="absolute left-1/2 -translate-x-1/2 font-semibold text-[18px]">
          {languageMap?.["menu.conversation.groupInfo"] ?? "Group information"}
        </span>
        <button
          type="button"
          aria-label="Close group information"
          onClick={() => setPanelStatus(null)}
          className="absolute right-3 cursor-pointer p-2"
        >
          <MdClose size={20} />
        </button>
      </div>
      {/* Content */}
      <div className="flex flex-col h-screen overflow-y-scroll w-[350px]">
        <PanelView
          jumpToMessage={jumpToMessage}
          openModal={openModal}
          isMail={isMail}
        />
      </div>
    </div>
  );
};

export { GroupInfoPanel };
